import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Vipingo";

const VipingoRidge = () => {
  const projectId = "PRJ00026";
  const title = "Ocean View Ridge - Vipingo";

  const mapConfig = {
    minZoom: 6,
    zoom: 9,
    bounds: [
      [29.0, -178.08],
      [24.4, -174.35],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/ocean-view-ridge-vipingo-by-optiven/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSehLBhQ_20-fmifpl0cx4aUWo9VT_jDppaU7qE-pW322h5YrA/viewform"
    />
  );
};

export default VipingoRidge;
